import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Home from "./pages/Home";
import Admin from "./pages/Admin";
import TherapyForChildren from "./pages/TherapyForChildren";
import TherapyForTeens from "./pages/TherapyForTeens";
import TherapyForWomen from "./pages/TherapyForWomen";
import EducationConsulting from "./pages/EducationConsulting";
import InHomeTherapy from "./pages/InHomeTherapy";
import FeesDocumentation from "./pages/FeesDocumentation";
import ReferAFamily from "./pages/ReferAFamily";
import StepUpScholarship from "./pages/StepUpScholarship";

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/therapy-for-children" element={<TherapyForChildren />} />
          <Route path="/therapy-for-teens" element={<TherapyForTeens />} />
          <Route path="/therapy-for-women" element={<TherapyForWomen />} />
          <Route path="/education-consulting-school-support" element={<EducationConsulting />} />
          <Route path="/in-home-therapy-lake-nona" element={<InHomeTherapy />} />
          <Route path="/fees-documentation" element={<FeesDocumentation />} />
          <Route path="/refer-a-family" element={<ReferAFamily />} />
          <Route path="/step-up-scholarship" element={<StepUpScholarship />} />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
